<template>
  <el-dialog
    title="会话详情"
    :visible.sync="dialogVisible"
    @close="handleClose"
    :modal="false"
    width="1000px">

    <div class="convercontent">
      <div style="background:#eaf7fd;height:36px;line-height:36px;padding-left:30px;display:flex;margin-bottom:5px">
        <div style="color:#e49149;border:1px solid #e49149;height:30px;line-height:30px;margin-top:3px;padding:0 5px" v-show="tracustomerType!=''">{{tracustomerType}}</div>
        <div style="margin-left:5px">{{travisitorName}}</div>
      </div>
      <!--<div style="margin-top:20px;font-weight:bolder;font-size:15px;border-bottom:1px solid #5faefe;color:#5faefe;width:60px">在线咨询</div>-->
      <div style="display:flex;">
        <div class="split_public split_left">
          <div class="left_top">
            <div class="font_style_set">客户详情:</div>
            <div class="content">
              <label>{{customerNameField}}:</label>
              <label>{{customerName}}</label>
            </div>
            <div class="content">
              <label>{{customerTypeField}}:</label>
              <label>{{customType}}</label>
            </div>
            <div class="content">
              <label>{{customerManagerField}}:</label>
              <label>{{customerManager}}</label>
            </div>
            <div class="content">
              <label>{{telephoneOneField}}:</label>
              <label>{{telephoneOne}}</label>
            </div>
            <div class="content_tab">
              <div style="width: 100px">
                <div class="content_top">{{num}}</div>
                <div class="content_down">会话次数</div>
              </div>
            </div>
          </div>
          <div class="left_bottom">
            <div class="content">
              <label>员工工号:</label>
              <label>{{agentNumberdetail}}</label>
            </div>
          </div>
        </div>


      <!--右侧记录start-->
        <div class="chatPage">
          <div class="taleBox" ref="scroller">
                    <div class="cusandstaff" v-for="(item,index) in convercontent" :key="index">
                        <div v-if="item.tip" class="msgTipDiv">
                          <span class="msgTip">{{item.createTime+ "  "+ item.tip}}</span>
                        </div>
                        <div class="online_cus" v-show="item.agentNumber=='' && item.content!=''"> <!-- 顾客 -->
                          <div  class="online_cus_infoimg">
                            <img :src="customerimg"  />
                          </div>
                          <div  class="online_cus_info" >
                            <div  class="online_cus_infodetail">
                              <p  class="online_cus_infoname"><span>{{item.value}}</span></p>
                              <p  class="online_cus_infotime">{{item.createTime}}</p>
                            </div>
                            <!-- <div class="online_cus_dialofont" >{{item.content}}</div> -->
                            <div class="online_cus_dialofont" >
                               <Msg :msgType="item.msgType" v-model="item.content"/>
                            </div>
                          </div>
                        </div>
                        <div class="online_staff" v-show="item.agentNumber!='' && item.content!=''"> <!-- 员工 -->
                          <div  class="online_staff_infobk">
                                <img :src="employeeHead"   class="online_staff_infoimg" />
                          </div>
                          <div  class="online_staff_info">
                            <div  class="online_staff_infodetail" >
                              <p  class="online_staff_infotime">{{item.createTime}}</p>
                              <p  class="online_staff_infoname">{{item.value}}</p>
                            </div>
                            <!-- <div class="online_staff_dialofont" style="border:1px solid red">{{item.content}}</div> -->
                            <div class="online_staff_dialofont">
                                <Msg :msgType="item.msgType" v-model="item.content"/>
                            </div>
                          </div>

                        </div>
                    </div>
          </div>
        </div>
       <!--右侧记录end-->
       </div>
    </div>
  </el-dialog>
</template>

<script>
  import Msg from '@/components/OnlineService/Msg.vue';
  export default {
    name: "conversationPop",
    props: ['recordId','travisitorName','tracustomerType', 'showSessionRecord','travService'],
    components:{
      Msg,
    },
    data(){
      return {
        dialogVisible:false,
        height:500,
        width:620,
        convercontent:[],
        listcont:[],
        customerimg:require('../../../assets/image/cusHead.png'),
        employeeHead:require( '../../../assets/image/onLineBlue.png'),
        customerimgtwo:require('../../../assets/image/cusHead.png'),
        employeeHeadtwo:require( '../../../assets/image/onLineBlue.png'),

        visitorName : '',
        customerName : '',
        customType : '',
        customerManager : '',
        telephoneOne :'',
        num : '',
        agentNumberdetail : '',

        customerNameField:'',
        customerTypeField:'',
        customerManagerField:'',
        telephoneOneField:'',

        msgType: 'text',
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        agentInfo:JSON.parse(localStorage.getItem("agentInfo")),
      }
    },
    methods:{
      initSearch(recordId) {
        let param = {
          id:recordId
        }
        let that = this;
        that.convercontent=[];
        this.$http.post("chatDetail/doSelectOne.json",param) .then(function (res) {
          let result = res.data;
          if (result.flag != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }

          let allDateList = result.obj;
          if(allDateList){
            if(allDateList.list){
              that.convercontent=allDateList.list;
              for(let i=0;i< that.convercontent.length;i++){
                if(that.convercontent[i].agentNumber==""&&that.convercontent[i].headImg!=""){//客户
                      that.customerimg=that.convercontent[i].headImg;
                }else if(that.convercontent[i].agentNumber==""&&that.convercontent[i].headImg==""){
                          that.customerimg=that.customerimgtwo;
                }
                if(that.convercontent[i].agentNumber!=""&&that.convercontent[i].headImg!=""){//客服
                       that.employeeHead=that.baseImgURL+that.convercontent[i].headImg;
                }else if(that.convercontent[i].agentNumber!=""&&that.convercontent[i].headImg==""){
                        that.employeeHead=that.employeeHeadtwo;
                }
                // if(that.convercontent[i].msgType=="image"){
                //       that.employeeMessImg=that.baseImgURL+that.convercontent[i].content;
                // }

              }
            }
          }

          let customerDetail=result.obj.listDetail;
          if(customerDetail.length>0){
              that.visitorName=customerDetail[0].visitorName;
              that.customerName=customerDetail[0].customerName;
              that.customType=customerDetail[0].customType;
              that.customerManager=customerDetail[0].customerManager;
              that.num=customerDetail[0].num;
              that.agentNumberdetail=customerDetail[0].agentNumber;
              if(that.agentInfo.isAdmin=='1'){
                 that.telephoneOne=customerDetail[0].telephoneOne;
                 return false;
              }
              if(that.configInfo.phoneIsHide=='0'){//显示全码
                  that.telephoneOne=customerDetail[0].telephoneOne;
              }else if(that.configInfo.phoneIsHide=='1'){//显示隐藏码
                  that.telephoneOne=customerDetail[0].telephoneOneHide
              }
          }


        });
      },
      getFields: function(){
          let that=this;
          let param={
            moduleId: "1",
            pageNum:0,
            pageSize:0
          };
          this.$http.post("custom/fields.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            let fields = res.data.obj.list.content;
            that.customerNameField = fields.find(item => item.customColName == 'customerName').customName;
            that.customerManagerField = fields.find(item => item.customColName == 'customerManager').customName;
            that.customerTypeField = fields.find(item => item.customColName == 'customerType').customName;
            that.telephoneOneField = fields.find(item => item.customColName == 'telephoneOne').customName;
          });
        },
      handleClose() {
        this.$emit('closeSessionRecord',true);
      },

    },
    watch:{
      showSessionRecord() {
        this.dialogVisible = this.showSessionRecord
        if (this.showSessionRecord) {
          this.getFields();
          this.initSearch(this.recordId)
        }
      }
    }
  }
</script>

<style scoped lang="css">
.convercontent{
  /* display: flex; */
  margin-top:-30px;
}
/* 右侧聊天记录start */
.chatPage{
  width: 650px;
  position: relative;
  background: #fff;
  overflow: hidden;
  border: 1px solid #CCCCCC;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.12), 0 0 6px rgba(0,0,0,0.04);
}
.taleBox {
    height: 500px;
    padding-bottom: 20px;
    overflow-y: auto;
 }
/*  */
.cusandstaff{
  margin: 10px 15px 0px 15px;
  font-size: 14px;
}
.online_cus{
  margin:10px 15px 0px 15px;
  display: flex;
}
.online_cus_info{
  overflow:hidden;
  width: 100%;
}
.online_cus_infoimg{
  width:38px;margin-right:10px;margin-top:5px;
}
.online_cus_infoimg  img{
    width:30px;
}
.online_cus_infodetail{
  display: flex;
  align-items:center;
}
.online_cus_infoname{
  color:#e49149;margin-right:10px;
}
.online_cus_infotime{
  color:#e49149;
}
.online_cus_dialofont{
  min-height: 30px;
  float:left;
  width:80%;
  color:#5c5c5b;
  font-size: 14px;
  text-align:left;
  letter-spacing:2px;
  white-space: pre-wrap;
}
.online_staff{
  margin:10px 15px 0px 15px;
  overflow: hidden;
}
.online_staff_infobk{
  width:38px;
  height:38px;
  border-radius: 50%;
  position:relative;
  float:right;
  margin-top:3px;
  margin-left:10px;
}
.online_staff_infoimg{
  border-radius:50%;
  width:36px;
  height:36px;
  margin-left:10px;
  position:absolute;
  left:50%;
  top:50%;
  margin-left:-18px;
  margin-top:-18px
}
.online_staff_info{
  overflow:hidden;
}
.online_staff_infodetail{
  float:right;
  display: flex;
  align-items:center;
}
.online_staff_infotime{
  color:#1d82fe;
  margin-right:10px;
}
.online_staff_infoname{
  color:#1d82fe;
}
.online_staff_dialofont{
  min-height: 30px;
  float:right;
  width:80%;
  color:#5c5c5b;
  font-size: 14px;
  text-align: right;
  letter-spacing:2px;
  white-space: pre-wrap;
}
.msgTipDiv{
    text-align: center;
    color: #666;
    margin: 10px;
}
.msgTip{
    max-width: 80%;
    overflow: hidden;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 12px;
    padding: 0 16px;
    line-height: 24px;
    color: #919ea7;
    margin-top: 10px;
    height: 24px;
    background: #f1f5f9;
    border-radius: 2px;
}
/* 右侧聊天记录end */

</style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/detailedReportForm/conversationPop.vue